import { withProps } from 'recompose'

import { locationSelector } from 'sfproxy/selectors'
import { countryFromHost } from 'shared/country'
import { getPaymentType } from 'shared/utils'

import Icon from '@components/Icon'

const paymentLabels = {
    americanExpress: ['label.park.americanExpress', 'americanExpress'],
    cash: ['label.park.cash', 'cash'],
    debit: ['label.park.debit', `${countryFromHost() === 'ca' ? 'debit-iterac' : 'debit'}`],
    masterCard: ['label.park.masterCard', 'masterCard'],
    phone: ['label.park.phone', 'phone'],
    visa: ['label.park.visa', 'visa'],
}

const Information = ({ payments }) => (
    <div className="card lavender">
        <div className="card-header">
            <h3>
                <T>label.park.information</T>
            </h3>
            <hr />
        </div>
        <div className="card-block">
            <ul>
                {payments.map(([label, paymentType], i) => (
                    <li className="d-flex align-items-center" key={`a${i}`}>
                        <Icon type={getPaymentType(paymentType)} size="sm" withShadow />
                        <T>{label}</T>
                    </li>
                ))}
            </ul>
        </div>
        <div className="card-footer" />
    </div>
)

export default compose(
    connect(locationSelector),
    withProps(({ payments = {} }) => ({
        payments: Object.keys(payments)
            .filter(payment => payments[payment] && paymentLabels[payment])
            .map(payment => paymentLabels[payment]),
    }))
)(Information)
